// ====================================
// SOURCE UNIQUE DES HORAIRES — modifiez ici pour ajuster (ex : horaires d'été)
// Jours : 0 = Dimanche, 1 = Lundi ... 6 = Samedi
// Valeur = [heure d'ouverture, heure de fermeture] en heures locales (Europe/Paris)
// ====================================
export const BUSINESS_SCHEDULE = {
  1: [11, 17], // Lundi
  2: [11, 17], // Mardi
  4: [11, 17], // Jeudi
  5: [11, 17], // Vendredi
};

export const TIMEZONE = 'Europe/Paris';

// Libellés réutilisables dans l'UI
export const HOURS_SHORT = 'Lun, Mar, Jeu, Ven : 11h–17h';
export const HOURS_SHORT_COMPACT = 'Lun, Mar, Jeu, Ven 11h–17h';
export const HOURS_CLOSED_NOTE = 'Fermé mer, sam, dim';
export const HOURS_DETAIL =
  "Je suis disponible les lundis, mardis, jeudis et vendredis, de 11h à 17h. Fermé le mercredi, le samedi et le dimanche. Le matin, j'entretiens une résidence privée à Brétignolles-sur-Mer.";

const DAY_NAMES = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

// Retourne l'état d'ouverture courant (heure de Paris) + le prochain créneau d'ouverture.
export const getBusinessStatus = (date = new Date()) => {
  const fr = new Date(date.toLocaleString('en-US', { timeZone: TIMEZONE }));
  const day = fr.getDay();
  const hourDecimal = fr.getHours() + fr.getMinutes() / 60;

  const range = BUSINESS_SCHEDULE[day];
  const isOpen = !!range && hourDecimal >= range[0] && hourDecimal < range[1];

  // Calcule la prochaine ouverture (aujourd'hui plus tard, ou un prochain jour ouvré)
  let nextLabel = '';
  if (!isOpen) {
    if (range && hourDecimal < range[0]) {
      nextLabel = `aujourd'hui à ${range[0]}h`;
    } else {
      for (let i = 1; i <= 7; i++) {
        const d = (day + i) % 7;
        if (BUSINESS_SCHEDULE[d]) {
          const open = BUSINESS_SCHEDULE[d][0];
          nextLabel = i === 1 ? `demain à ${open}h` : `${DAY_NAMES[d]} à ${open}h`;
          break;
        }
      }
    }
  }

  return { isOpen, nextLabel };
};
